module.exports = __webpack_public_path__ + "static/img/packaged-liquid-biofuel_64.f37b3e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packaged-liquid-biofuel_64.png
// module id = IG4P
// module chunks = 0